import React, { ReactNode } from "react";
import UploadIcon from '@mui/icons-material/Upload';
import { Button, Stack, SvgIcon, Typography } from "@mui/material";


export default function EmptyContent({
    disabled = false,
    onButtonClick,
    Icon = UploadIcon,
    dragText = "Arrastra aquí el Archivo",
    buttonText = "Seleccionar Archivo"
}: {
    disabled?: boolean,
    onButtonClick: () => void,
    Icon?: React.FC,
    dragText?: ReactNode,
    buttonText?: ReactNode
}) {
    return <Stack justifyContent={"center"} alignItems={"center"} sx={{ pointerEvents: "none" }}>
        <SvgIcon sx={{ fontSize: "5rem", color: "grey.500" }}><Icon /></SvgIcon>
        <Typography color={disabled ? "text.disabled" : "text.primary"}>{dragText}</Typography>
        <Button
            onClick={onButtonClick}
            sx={{ cursor: "pointer", pointerEvents: "auto" }}
            disabled={disabled}
        >{buttonText}</Button>
    </Stack>
}